import z from 'zod';

export const taskTagSchema = z.object({
    id: z.number().int(),
    name: z.string(),
    fontColor: z.string(),
    backgroundColor: z.string(),
    isActive: z.boolean(),
});

export type TaskTag = z.infer<typeof taskTagSchema>;
